const isLoading = false
const withdrawPaymentsList = []
const withdrawBookingsList = []
const attractionsPaymentsList = []
const currentWithdraw = {
    id: null, uuid: "", vendorId: "", vendorTax: "",
    value: 0, orders: [], created: "", processed: false,
    pixHash: null, placeUuid: "", obs: "",
    info: {
        month: "", period: { start: "", end: "", }, last_pos_cred: 0, last_online_cred: 0,
        online_cred: 0, online_deb: 0, online_pix: 0, online_wallet: 0,
        pos_cred: 0, pos_deb: 0, pos_pix: 0, local_money: 0,
        pois_tax: 0
    }
}

export default {
    withdrawPaymentsList,
    withdrawBookingsList,
    attractionsPaymentsList,
    currentWithdraw,
    isLoading,
}